import React, { useEffect } from 'react';
import type { FC } from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { create } from 'jss';
import rtl from 'jss-rtl';
import MomentUtils from '@date-io/moment';
import { SnackbarProvider } from 'notistack';
import { jssPreset, StylesProvider, ThemeProvider } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import GlobalStyles from './components/GlobalStyles';
import ScrollReset from './components/ScrollReset';
import GoogleAnalytics from './components/GoogleAnalytics';
// import { AuthProvider } from './contexts/JWTAuthContext';
import useSettings from './hooks/useSettings';
import { createTheme } from './theme';
import routes, { renderRoutes } from './routes';
import { withWidth } from '@material-ui/core';
import { setScreenSizeAction } from './reducers/global';
import { useDispatch } from './store';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
const history = createBrowserHistory();

const App: FC<{ width: string }> = ({ width }) => {
  const { settings } = useSettings();
  const dispatch = useDispatch();
  const theme = createTheme({
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    theme: settings.theme,
  });

  // 스크린 사이즈 및 화면 방향 정보 저장
  useEffect(() => {
    dispatch(setScreenSizeAction(width, screen.orientation));
  }, [document.body.clientWidth]);

  return (
    <ThemeProvider theme={theme}>
      <StylesProvider jss={jss}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <SnackbarProvider dense maxSnack={3}>
            <Router history={history}>
              {/* <AuthProvider> */}
              <GlobalStyles />
              <ScrollReset />
              <GoogleAnalytics />
              {renderRoutes(routes)}
              {/* </AuthProvider> */}
            </Router>
          </SnackbarProvider>
        </MuiPickersUtilsProvider>
      </StylesProvider>
    </ThemeProvider>
  );
};

export default withWidth()(App);
